import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApplicationResponse } from "@src/common/domain/common.model";
import api from "@src/common/services/api.service";
import AppConstants from "@src/utils/app.constants";
import convertToForm from "@src/utils/payload-to-form-converter";
import { ProjectDepartmentModelRef } from "@views/project-plan/domain/project-plan.domain";

export const fetchRevisionList = createAsyncThunk<
  any[],
  { projectId: string; type: string }
>("revision/fetchRevision", async ({ projectId, type }) => {
  const url = `${AppConstants.api}/revision/${type}/${projectId}`;
    const response = await api.get<ApplicationResponse<any[]>>(url, {
      params: {
        id: projectId,
      },
    });
    return response.data.data || [];
});

export const createProjectRevision = createAsyncThunk<string, { payload: any }>(
  "project/create-revision",
  async ({ payload }) => {
    const url = `${AppConstants.api}/revision`;
    const response = await api.post<ApplicationResponse<string>>(url, payload, {
      params: {
        RAR: 0,
      },
    });
    if (response.data.status === "ERROR") {
      throw new Error(response.data.message);
    }
    return response.data.data || "";
  }
);

// export const createProjectRevision = createAsyncThunk<string, { payload: any }>(
//   "project/create-revision",
//   async ({ payload }) => {
//     const url = `${AppConstants.api}/revision`;
//     const response = await api.post<ApplicationResponse<string>>(url, payload, {
//       // headers: {
//       //   "Content-Type": "multipart/form-data",
//       // },
//     });
//     if (response.data.status === "ERROR") {
//       throw new Error(response.data.message);
//     }
//     return response.data.data || "";
//   }
// );


export const uploadRevisionFile = createAsyncThunk<string, { payload: any }>(
  "project/upload-revision-file",
  async ({ payload }) => {
    const keys = Object.keys(payload);
    const formData = convertToForm(payload, keys);
    const url = `${AppConstants.api}/revision/upload`;
    const response = await api.post<ApplicationResponse<string>>(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response.data.status === "ERROR") {
      throw new Error(response.data.message);
    }

    return response.data.data || "";
  }
);

export const revisionProject = createAsyncThunk<
  any,
  { id: string; payload: any; type: "npms" | "eci" | "custom" }
>("revision/revisionProject", async ({ id, payload, type }) => {
  const url = `${AppConstants.api}/${type}/revision`;
  const response = await api.put<ApplicationResponse<any>>(url, payload, {
    params: {
      id: id,
    },
  });
  return response.data.data || {};
});
export const fetchRevisionInfo = createAsyncThunk(
  "revision/fetchRevisionInfo",
  async (id:string) => {
    const response = await api.get<ApplicationResponse<any>>(
      `${AppConstants.api}/revision?id=${id}`
    );
    return response.data.data || [];
  }
);


export const fetchProjectDepartments = createAsyncThunk<
  ProjectDepartmentModelRef[],
  {
    projectId: string;
    type: string;
  }
>("hodStatus/changeStatus", async ({ projectId, type }) => {
  const url = `${AppConstants.api}/projectDepartment`;
  const response = await api.get<
    ApplicationResponse<ProjectDepartmentModelRef[]>
  >(url, {
    params: {
      projectId,
      type,
      RAR: 0,
    },
  });
  return response.data.data || [];
});

const RevisionListSlice = createSlice({
  name: "revision",
  initialState: {
    minimal: { status: "loading", error: null, data: [] },
    revisionInfo: { status: "loading", error: null, data: [] },
    projectDepartments: { status: "loading", error: null, data: [] },
  } as any,
  reducers: {
    resetState: (state) => {
      return {
        minimal: { status: "loading", error: null, data: [] },
      };
    },
    resetRevision: (state) => {
      return {
        revisionInfo: { status: "loading", error: null, data: [] },
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRevisionList.pending, (state, action) => {
        state.minimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchRevisionList.fulfilled, (state, action) => {
        state.minimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchRevisionList.rejected, (state, action) => {
        state.minimal = {
          status: "failed",
          data: [],
          error: action.error.message,
        };
      })
      .addCase(fetchRevisionInfo.pending, (state) => {
        state.revisionInfo = {
          status: "loading",
          data: {},
          error: null,
        };
      })
      .addCase(fetchRevisionInfo.fulfilled, (state, action) => {
        state.revisionInfo = {
          status: "idle",
          data: { ...action.payload },
          error: null,
        };
      })
      .addCase(fetchRevisionInfo.rejected, (state, action) => {
        state.revisionInfo = {
          status: "failed",
          data: {},
          error: action.error.message,
        };
      })
      .addCase(fetchProjectDepartments.pending, (state) => {
        state.projectDepartments = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchProjectDepartments.fulfilled, (state, action) => {
        state.projectDepartments = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchProjectDepartments.rejected, (state) => {
        state.projectDepartments = {
          status: "loading",
          data: [],
          error: null,
        };
      });
  },
});

export const { resetState } = RevisionListSlice.actions;
export default RevisionListSlice.reducer;
